export default "__VITE_ASSET__hRqlXZAD__"